(() => {
  const attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid', 'msclkid', 'fbclid', 'ttclid'];

  const analyticsAllowed = () => {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !privacy || !privacy.analyticsProcessingAllowed || privacy.analyticsProcessingAllowed();
    } catch (_) { return false; }
  };

  const appendAttribution = (href) => {
    try {
      const destination = new URL(href, window.location.href);
      const query = new URLSearchParams(window.location.search);
      attributionKeys.forEach((key) => {
        const value = query.get(key);
        if (value && !destination.searchParams.has(key)) destination.searchParams.set(key, value);
      });
      return destination.toString();
    } catch (_) { return href; }
  };

  document.querySelectorAll('[data-fvr-root]').forEach((root) => {
    if (root.dataset.fvrInitialized === 'true') return;
    root.dataset.fvrInitialized = 'true';

    const emit = (event, detail = {}, once = false) => {
      if (!analyticsAllowed()) return;
      const key = `fvr:${event}`;
      if (once && sessionStorage.getItem(key)) return;
      if (once) sessionStorage.setItem(key, 'true');
      const params = new URLSearchParams(window.location.search);
      const campaign = attributionKeys.reduce((result, name) => {
        const value = params.get(name);
        if (value) result[name] = value;
        return result;
      }, {});
      const payload = {
        event,
        page_id: 'forge_vs_ridge',
        forge_price: root.dataset.forgePrice,
        competitor_price: root.dataset.competitorPrice,
        last_fact_check: root.dataset.lastChecked,
        ...campaign,
        ...detail,
      };
      document.dispatchEvent(new CustomEvent('forge:analytics', { detail: payload }));
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    };

    root.querySelectorAll('[data-fvr-pdp]').forEach((link) => {
      link.href = appendAttribution(link.href);
    });

    root.querySelectorAll('[data-fvr-cta]').forEach((cta) => {
      cta.addEventListener('click', () => {
        const id = cta.dataset.fvrCta;
        const event = id === 'hero-comparison' || id === 'hero-pdp' ? 'hero_cta_click' : id === 'final-pdp' ? 'final_cta_click' : id === 'sticky-pdp' ? 'sticky_cta_click' : 'midpage_cta_click';
        emit(event, { cta_id: id, source_section: cta.dataset.fvrLocation || '', cta_text: cta.textContent.trim() });
      });
    });

    root.querySelectorAll('[data-fvr-scroll]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = root.querySelector(`#${button.dataset.fvrScroll}`);
        if (target) target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    });

    root.querySelectorAll('[data-fvr-faq]').forEach((button) => {
      button.addEventListener('click', () => {
        const answer = root.querySelector(`#${button.getAttribute('aria-controls')}`);
        const opening = button.getAttribute('aria-expanded') !== 'true';
        root.querySelectorAll('[data-fvr-faq]').forEach((item) => {
          item.setAttribute('aria-expanded', 'false');
          const panel = root.querySelector(`#${item.getAttribute('aria-controls')}`);
          if (panel) panel.hidden = true;
          const sign = item.querySelector('[data-fvr-sign]');
          if (sign) sign.textContent = '+';
        });
        if (opening && answer) {
          button.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
          const sign = button.querySelector('[data-fvr-sign]');
          if (sign) sign.textContent = '−';
          emit('faq_open', { source_section: 'faq', question_id: button.dataset.fvrFaq });
        }
      });
    });

    const methodology = root.querySelector('[data-fvr-method]');
    if (methodology) {
      methodology.addEventListener('click', () => {
        const content = root.querySelector(`#${methodology.getAttribute('aria-controls')}`);
        const opening = methodology.getAttribute('aria-expanded') !== 'true';
        methodology.setAttribute('aria-expanded', String(opening));
        if (content) content.hidden = !opening;
        const sign = methodology.querySelector('[data-fvr-method-sign]');
        if (sign) sign.textContent = opening ? '−' : '+';
        if (opening) emit('comparison_interaction', { interaction_type: 'methodology_open', source_section: 'trust' });
      });
    }

    const header = root.querySelector('.fvr-header');
    const utility = root.querySelector('.fvr-utility');
    const comparison = root.querySelector('#fvr-comparison');
    const finalPanel = root.querySelector('#fvr-final-decision');
    const sticky = root.querySelector('.fvr-sticky');
    const updateChrome = () => {
      const mobile = window.matchMedia('(max-width: 767px)').matches;
      const heroComplete = root.getBoundingClientRect().top < -84;
      const comparisonComplete = comparison && comparison.getBoundingClientRect().bottom < 56;
      const finalVisible = finalPanel && finalPanel.getBoundingClientRect().top < window.innerHeight * .78 && finalPanel.getBoundingClientRect().bottom > window.innerHeight * .2;
      if (header) header.classList.toggle('is-scrolled', window.scrollY > 84);
      if (utility) utility.classList.toggle('is-visible', Boolean(heroComplete && !mobile && !finalVisible));
      if (sticky) sticky.classList.toggle('is-visible', Boolean(mobile && comparisonComplete && !finalVisible));
    };
    window.addEventListener('scroll', updateChrome, { passive: true });
    window.addEventListener('resize', updateChrome);
    updateChrome();
    emit('prelander_view', { comparison: 'forge_vs_ridge' }, true);
  });
})();
/* Mobile Safari video autoplay fallback */
document.querySelectorAll('[data-fvr-root] video').forEach((video) => {
  video.muted = true;
  video.defaultMuted = true;
  video.playsInline = true;

  const tryPlay = () => {
    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.catch(() => {});
    }
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            tryPlay();
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(video);
  } else {
    tryPlay();
  }

  video.addEventListener('loadeddata', tryPlay);
  video.addEventListener('canplay', tryPlay);
});

window.addEventListener('pageshow', () => {
  document.querySelectorAll('[data-fvr-root] video').forEach((video) => {
    video.muted = true;
    video.play().catch(() => {});
  });
});